export default "__VITE_ASSET__942e2f3f__"